import template   from './update-item.html'
import './update-item.styl'

let component = {
  restrict: 'E',
  bindings: {
    item: '<',
    onUpdateClick: '&'
  },
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/components/update-item/update-item.component.js